export interface PlanMeta {
    name: string; // "Plan Name"
    id: string; // "WPA_234_234"
}

/** Benefit Objects (start) */
export interface MedicalBenefit {
    inNetwork?: string;
    inNetworkTier1?: string;
    inNetworkTier2?: string;
    outOfNetwork?: string;
    YTD?: string;
    Limit?: string;
}

export interface BenefitValue {
    [benefitId: string]: MedicalBenefit | string;
}

 
export interface BenefitMeta {
    name: string;
    id: string; // Aligns with PlanMeta
    // If any of the mapped plans have an out-of-network benefit
    atLeastOneOON: boolean;
    // If any of the mapped plans have an in-network benefit
    atLeastOneINN: boolean;
}

export interface BenefitsByPlanCollection {
    [planId: string]: BenefitValue; // { "WPA_234_332": [{ value: "$10 deductible", id: '1' }]}
}

export enum BENEFITS_TYPES {
    PRESCRIPTION_DRUGS = 'PRESCRIPTION_DRUGS',
    PRESCRIPTION_DRUG_COVERAGE = 'PRESCRIPTION_DRUG_COVERAGE',
    MEDICAL_BENEFIT = 'MEDICAL_BENEFIT',
    ICONOGRAPHY = 'ICONOGRAPHY',
    PLAN_DOCUMENTS = 'PLAN_DOCUMENTS'
}
export interface PlanDetailsRenderableGroup {
    name: string; // 'Medical Services',
    plans: PlanMeta[]; // ['plan 1', 'plan 2'],
    benefits: BenefitMeta[]; // [{name:'benefit name', id: '1'}],
    planBenefits: BenefitsByPlanCollection;
    benefitsType: BENEFITS_TYPES;
    hideLabel: boolean;
}

/* Post-transform */
export interface RetailTierData {
    nonPreferredBrand: string;
    generic: string;
    preferredBrand: string;
    preferredGeneric: string;
    specialty: string;
}
export interface MailTierData {
    nonPreferredBrand: string;
    nonPreferredGeneric: string;
    preferredBrand: string;
    preferredGeneric: string;
    preferredSpecialty: string;
}

export interface RxTiersFormatted {
    formulary: string;
    preferredMail: MailTierData;
    standardMail: MailTierData;
    preferredRetail: RetailTierData;
    standardRetail: RetailTierData;
    coverageGap: {
        preferred: string;
        standard: string;
    };
    catastrophic: string;
} 

export interface AnnualCost {
    YTD: string;
}

/** Benefit Objects (end) */

export interface BenefitMeta {
    name: string;
    id: string; // Aligns with PlanMeta
    // If any of the mapped plans have an out-of-network benefit
    atLeastOneOON: boolean;
    // If any of the mapped plans have an in-network benefit
    atLeastOneINN: boolean;
}

export interface PlanDetailsRenderableCategory {
    categoryName: string; // 'Health Benefits',
    benefitGroupData: PlanDetailsRenderableGroup[];
    hideLabel: boolean;
}
